import { useContext } from 'react';
import { FEATURES_LIST, FeatureSwitchContext } from '../context/featureSwitch';
import { isFeatureEnabled } from '@utils/featureSwitches.utils';

export const useFeatureSwitchEnabled = (name: FEATURES_LIST, value?: any): boolean => {
    const context = useContext(FeatureSwitchContext);

    return isFeatureEnabled(name, context, value);
};
